import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { MenuItem, Select } from '@mui/material';
import { RM3_SORT } from 'arbitrip-common/client/utils/HotelDealsRm3';

const SORT_LABEL_KEYS = {
    [RM3_SORT.PRICE]: 'HotelDealsRm3.SortPrice',
    [RM3_SORT.CANCELLATION_DATE]: 'HotelDealsRm3.SortCancellationDate',
};

/** "Sort by: **X**" (spec §1.2, Q2): Price / Cancellation date; the latter disabled with no refundable deal. */
function Rm3SortSelect({ value, onChange, cancellationDisabled }) {
    const { t } = useTranslation();
    return (
        <Select
            className="rm3-sort-select"
            value={value}
            onChange={(event) => onChange(event.target.value)}
            variant="outlined"
            renderValue={(selected) => (
                <Trans
                    i18nKey="HotelDealsRm3.SortByValue"
                    values={{ value: t(SORT_LABEL_KEYS[selected]) }}
                    components={{ strong: <strong /> }}
                />
            )}
            inputProps={{ 'data-testid': 'room-sort-dropdown' }}
        >
            <MenuItem value={RM3_SORT.PRICE}>{t(SORT_LABEL_KEYS[RM3_SORT.PRICE])}</MenuItem>
            <MenuItem value={RM3_SORT.CANCELLATION_DATE} disabled={cancellationDisabled}>
                {t(SORT_LABEL_KEYS[RM3_SORT.CANCELLATION_DATE])}
            </MenuItem>
        </Select>
    );
}

export default Rm3SortSelect;
